"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Aida API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonitoringApi = exports.MonitoringApiFactory = exports.MonitoringApiFp = exports.MonitoringApiAxiosParamCreator = exports.ModelsApi = exports.ModelsApiFactory = exports.ModelsApiFp = exports.ModelsApiAxiosParamCreator = exports.FilesApi = exports.FilesApiFactory = exports.FilesApiFp = exports.FilesApiAxiosParamCreator = exports.DownloadApi = exports.DownloadApiFactory = exports.DownloadApiFp = exports.DownloadApiAxiosParamCreator = exports.ConversationsApi = exports.ConversationsApiFactory = exports.ConversationsApiFp = exports.ConversationsApiAxiosParamCreator = exports.UserFeedback = exports.ProcessingStatus = exports.PrivacyLevel = exports.MessageType = exports.GenerationStatus = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * The status of generated responses. User inputed messages default to done.
 * @export
 * @enum {string}
 */
exports.GenerationStatus = {
    Done: 'done',
    InProgress: 'inProgress',
    Aborted: 'aborted'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MessageType = {
    UserInput: 'userInput',
    GeneratedResponse: 'generatedResponse'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.PrivacyLevel = {
    Private: 'private',
    Public: 'public',
    Internal: 'internal'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ProcessingStatus = {
    NotStarted: 'not started',
    InProgress: 'in progress',
    Done: 'done',
    Error: 'error'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.UserFeedback = {
    Like: 'like',
    Dislike: 'dislike'
};
/**
 * ConversationsApi - axios parameter creator
 * @export
 */
var ConversationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get all the user\'s conversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/conversations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a conversation and all its data.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('conversationsIdDelete', 'id', id);
                            localVarPath = "/conversations/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a specific conversation
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('conversationsIdGet', 'id', id);
                            localVarPath = "/conversations/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all the messages of a conversation.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdMessagesGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('conversationsIdMessagesGet', 'id', id);
                            localVarPath = "/conversations/{id}/messages"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a specific message
         * @param {string} id The conversation ID
         * @param {string} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdMessagesMessageIdGet: function (id, messageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('conversationsIdMessagesMessageIdGet', 'id', id);
                            // verify required parameter 'messageId' is not null or undefined
                            (0, common_1.assertParamExists)('conversationsIdMessagesMessageIdGet', 'messageId', messageId);
                            localVarPath = "/conversations/{id}/messages/{message-id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("message-id", "}"), encodeURIComponent(String(messageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a message\'s editable metadata.
         * @param {string} id The conversation ID
         * @param {string} messageId
         * @param {string} datetimeLastUpdated
         * @param {MessageMetadata} [messageMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdMessagesMessageIdPatch: function (id, messageId, datetimeLastUpdated, messageMetadata, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('conversationsIdMessagesMessageIdPatch', 'id', id);
                            // verify required parameter 'messageId' is not null or undefined
                            (0, common_1.assertParamExists)('conversationsIdMessagesMessageIdPatch', 'messageId', messageId);
                            // verify required parameter 'datetimeLastUpdated' is not null or undefined
                            (0, common_1.assertParamExists)('conversationsIdMessagesMessageIdPatch', 'datetimeLastUpdated', datetimeLastUpdated);
                            localVarPath = "/conversations/{id}/messages/{message-id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("message-id", "}"), encodeURIComponent(String(messageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (datetimeLastUpdated !== undefined) {
                                localVarQueryParameter['datetimeLastUpdated'] = datetimeLastUpdated;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(messageMetadata, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Start a stream to generate and populate the text content of a generated response message, based on the previous user input message. Returns the message text stream.
         * @param {string} id The conversation ID
         * @param {string} messageId The (skeleton) generated response message ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdMessagesMessageIdStreamsPost: function (id, messageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('conversationsIdMessagesMessageIdStreamsPost', 'id', id);
                            // verify required parameter 'messageId' is not null or undefined
                            (0, common_1.assertParamExists)('conversationsIdMessagesMessageIdStreamsPost', 'messageId', messageId);
                            localVarPath = "/conversations/{id}/messages/{message-id}/streams"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("message-id", "}"), encodeURIComponent(String(messageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Post a new user input message and generated response message (without the generated response text content) to the conversation. Call the POST .../messages/{message-id}/streams endpoint with the generated response message ID to generate the response text content. Returns both newly created messages.
         * @param {string} id
         * @param {UserInput} [userInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdMessagesPost: function (id, userInput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('conversationsIdMessagesPost', 'id', id);
                            localVarPath = "/conversations/{id}/messages"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userInput, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a conversation\'s editable metadata
         * @param {string} id
         * @param {string} datetimeLastUpdated
         * @param {ConversationMetadata} [conversationMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdPatch: function (id, datetimeLastUpdated, conversationMetadata, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('conversationsIdPatch', 'id', id);
                            // verify required parameter 'datetimeLastUpdated' is not null or undefined
                            (0, common_1.assertParamExists)('conversationsIdPatch', 'datetimeLastUpdated', datetimeLastUpdated);
                            localVarPath = "/conversations/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (datetimeLastUpdated !== undefined) {
                                localVarQueryParameter['datetimeLastUpdated'] = datetimeLastUpdated;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(conversationMetadata, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new empty conversation object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsPost: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/conversations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ConversationsApiAxiosParamCreator = ConversationsApiAxiosParamCreator;
/**
 * ConversationsApi - functional programming interface
 * @export
 */
var ConversationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ConversationsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get all the user\'s conversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.conversationsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a conversation and all its data.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdDelete: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.conversationsIdDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a specific conversation
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdGet: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.conversationsIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all the messages of a conversation.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdMessagesGet: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.conversationsIdMessagesGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a specific message
         * @param {string} id The conversation ID
         * @param {string} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdMessagesMessageIdGet: function (id, messageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.conversationsIdMessagesMessageIdGet(id, messageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a message\'s editable metadata.
         * @param {string} id The conversation ID
         * @param {string} messageId
         * @param {string} datetimeLastUpdated
         * @param {MessageMetadata} [messageMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdMessagesMessageIdPatch: function (id, messageId, datetimeLastUpdated, messageMetadata, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.conversationsIdMessagesMessageIdPatch(id, messageId, datetimeLastUpdated, messageMetadata, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Start a stream to generate and populate the text content of a generated response message, based on the previous user input message. Returns the message text stream.
         * @param {string} id The conversation ID
         * @param {string} messageId The (skeleton) generated response message ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdMessagesMessageIdStreamsPost: function (id, messageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.conversationsIdMessagesMessageIdStreamsPost(id, messageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post a new user input message and generated response message (without the generated response text content) to the conversation. Call the POST .../messages/{message-id}/streams endpoint with the generated response message ID to generate the response text content. Returns both newly created messages.
         * @param {string} id
         * @param {UserInput} [userInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdMessagesPost: function (id, userInput, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.conversationsIdMessagesPost(id, userInput, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a conversation\'s editable metadata
         * @param {string} id
         * @param {string} datetimeLastUpdated
         * @param {ConversationMetadata} [conversationMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdPatch: function (id, datetimeLastUpdated, conversationMetadata, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.conversationsIdPatch(id, datetimeLastUpdated, conversationMetadata, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new empty conversation object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsPost: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.conversationsPost(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ConversationsApiFp = ConversationsApiFp;
/**
 * ConversationsApi - factory interface
 * @export
 */
var ConversationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ConversationsApiFp)(configuration);
    return {
        /**
         *
         * @summary Get all the user\'s conversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsGet: function (options) {
            return localVarFp.conversationsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a conversation and all its data.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdDelete: function (id, options) {
            return localVarFp.conversationsIdDelete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a specific conversation
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdGet: function (id, options) {
            return localVarFp.conversationsIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all the messages of a conversation.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdMessagesGet: function (id, options) {
            return localVarFp.conversationsIdMessagesGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a specific message
         * @param {string} id The conversation ID
         * @param {string} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdMessagesMessageIdGet: function (id, messageId, options) {
            return localVarFp.conversationsIdMessagesMessageIdGet(id, messageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a message\'s editable metadata.
         * @param {string} id The conversation ID
         * @param {string} messageId
         * @param {string} datetimeLastUpdated
         * @param {MessageMetadata} [messageMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdMessagesMessageIdPatch: function (id, messageId, datetimeLastUpdated, messageMetadata, options) {
            return localVarFp.conversationsIdMessagesMessageIdPatch(id, messageId, datetimeLastUpdated, messageMetadata, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Start a stream to generate and populate the text content of a generated response message, based on the previous user input message. Returns the message text stream.
         * @param {string} id The conversation ID
         * @param {string} messageId The (skeleton) generated response message ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdMessagesMessageIdStreamsPost: function (id, messageId, options) {
            return localVarFp.conversationsIdMessagesMessageIdStreamsPost(id, messageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post a new user input message and generated response message (without the generated response text content) to the conversation. Call the POST .../messages/{message-id}/streams endpoint with the generated response message ID to generate the response text content. Returns both newly created messages.
         * @param {string} id
         * @param {UserInput} [userInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdMessagesPost: function (id, userInput, options) {
            return localVarFp.conversationsIdMessagesPost(id, userInput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a conversation\'s editable metadata
         * @param {string} id
         * @param {string} datetimeLastUpdated
         * @param {ConversationMetadata} [conversationMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsIdPatch: function (id, datetimeLastUpdated, conversationMetadata, options) {
            return localVarFp.conversationsIdPatch(id, datetimeLastUpdated, conversationMetadata, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a new empty conversation object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsPost: function (options) {
            return localVarFp.conversationsPost(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ConversationsApiFactory = ConversationsApiFactory;
/**
 * ConversationsApi - object-oriented interface
 * @export
 * @class ConversationsApi
 * @extends {BaseAPI}
 */
var ConversationsApi = /** @class */ (function (_super) {
    __extends(ConversationsApi, _super);
    function ConversationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get all the user\'s conversations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    ConversationsApi.prototype.conversationsGet = function (options) {
        var _this = this;
        return (0, exports.ConversationsApiFp)(this.configuration).conversationsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a conversation and all its data.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    ConversationsApi.prototype.conversationsIdDelete = function (id, options) {
        var _this = this;
        return (0, exports.ConversationsApiFp)(this.configuration).conversationsIdDelete(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a specific conversation
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    ConversationsApi.prototype.conversationsIdGet = function (id, options) {
        var _this = this;
        return (0, exports.ConversationsApiFp)(this.configuration).conversationsIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all the messages of a conversation.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    ConversationsApi.prototype.conversationsIdMessagesGet = function (id, options) {
        var _this = this;
        return (0, exports.ConversationsApiFp)(this.configuration).conversationsIdMessagesGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a specific message
     * @param {string} id The conversation ID
     * @param {string} messageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    ConversationsApi.prototype.conversationsIdMessagesMessageIdGet = function (id, messageId, options) {
        var _this = this;
        return (0, exports.ConversationsApiFp)(this.configuration).conversationsIdMessagesMessageIdGet(id, messageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a message\'s editable metadata.
     * @param {string} id The conversation ID
     * @param {string} messageId
     * @param {string} datetimeLastUpdated
     * @param {MessageMetadata} [messageMetadata]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    ConversationsApi.prototype.conversationsIdMessagesMessageIdPatch = function (id, messageId, datetimeLastUpdated, messageMetadata, options) {
        var _this = this;
        return (0, exports.ConversationsApiFp)(this.configuration).conversationsIdMessagesMessageIdPatch(id, messageId, datetimeLastUpdated, messageMetadata, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Start a stream to generate and populate the text content of a generated response message, based on the previous user input message. Returns the message text stream.
     * @param {string} id The conversation ID
     * @param {string} messageId The (skeleton) generated response message ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    ConversationsApi.prototype.conversationsIdMessagesMessageIdStreamsPost = function (id, messageId, options) {
        var _this = this;
        return (0, exports.ConversationsApiFp)(this.configuration).conversationsIdMessagesMessageIdStreamsPost(id, messageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post a new user input message and generated response message (without the generated response text content) to the conversation. Call the POST .../messages/{message-id}/streams endpoint with the generated response message ID to generate the response text content. Returns both newly created messages.
     * @param {string} id
     * @param {UserInput} [userInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    ConversationsApi.prototype.conversationsIdMessagesPost = function (id, userInput, options) {
        var _this = this;
        return (0, exports.ConversationsApiFp)(this.configuration).conversationsIdMessagesPost(id, userInput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a conversation\'s editable metadata
     * @param {string} id
     * @param {string} datetimeLastUpdated
     * @param {ConversationMetadata} [conversationMetadata]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    ConversationsApi.prototype.conversationsIdPatch = function (id, datetimeLastUpdated, conversationMetadata, options) {
        var _this = this;
        return (0, exports.ConversationsApiFp)(this.configuration).conversationsIdPatch(id, datetimeLastUpdated, conversationMetadata, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a new empty conversation object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    ConversationsApi.prototype.conversationsPost = function (options) {
        var _this = this;
        return (0, exports.ConversationsApiFp)(this.configuration).conversationsPost(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ConversationsApi;
}(base_1.BaseAPI));
exports.ConversationsApi = ConversationsApi;
/**
 * DownloadApi - axios parameter creator
 * @export
 */
var DownloadApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Retrieve and download the original file with the specific id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesIdOriginalFileDownloadGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('filesIdOriginalFileDownloadGet', 'id', id);
                            localVarPath = "/files/{id}/original-file/download"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve and download the processed file with the specific id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesIdProcessedFileDownloadGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('filesIdProcessedFileDownloadGet', 'id', id);
                            localVarPath = "/files/{id}/processed-file/download"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DownloadApiAxiosParamCreator = DownloadApiAxiosParamCreator;
/**
 * DownloadApi - functional programming interface
 * @export
 */
var DownloadApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DownloadApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Retrieve and download the original file with the specific id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesIdOriginalFileDownloadGet: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filesIdOriginalFileDownloadGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve and download the processed file with the specific id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesIdProcessedFileDownloadGet: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filesIdProcessedFileDownloadGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DownloadApiFp = DownloadApiFp;
/**
 * DownloadApi - factory interface
 * @export
 */
var DownloadApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DownloadApiFp)(configuration);
    return {
        /**
         *
         * @summary Retrieve and download the original file with the specific id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesIdOriginalFileDownloadGet: function (id, options) {
            return localVarFp.filesIdOriginalFileDownloadGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve and download the processed file with the specific id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesIdProcessedFileDownloadGet: function (id, options) {
            return localVarFp.filesIdProcessedFileDownloadGet(id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DownloadApiFactory = DownloadApiFactory;
/**
 * DownloadApi - object-oriented interface
 * @export
 * @class DownloadApi
 * @extends {BaseAPI}
 */
var DownloadApi = /** @class */ (function (_super) {
    __extends(DownloadApi, _super);
    function DownloadApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Retrieve and download the original file with the specific id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadApi
     */
    DownloadApi.prototype.filesIdOriginalFileDownloadGet = function (id, options) {
        var _this = this;
        return (0, exports.DownloadApiFp)(this.configuration).filesIdOriginalFileDownloadGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve and download the processed file with the specific id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadApi
     */
    DownloadApi.prototype.filesIdProcessedFileDownloadGet = function (id, options) {
        var _this = this;
        return (0, exports.DownloadApiFp)(this.configuration).filesIdProcessedFileDownloadGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DownloadApi;
}(base_1.BaseAPI));
exports.DownloadApi = DownloadApi;
/**
 * FilesApi - axios parameter creator
 * @export
 */
var FilesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get all the user\'s file record objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/files";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a file record object with a specific id and its associated files.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesIdDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('filesIdDelete', 'id', id);
                            localVarPath = "/files/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a file record object with a specific id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('filesIdGet', 'id', id);
                            localVarPath = "/files/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a file record object with a specific id
         * @param {string} id
         * @param {string} datetimeLastUpdated
         * @param {FileRecordMetadata} [fileRecordMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesIdPatch: function (id, datetimeLastUpdated, fileRecordMetadata, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('filesIdPatch', 'id', id);
                    // verify required parameter 'datetimeLastUpdated' is not null or undefined
                    (0, common_1.assertParamExists)('filesIdPatch', 'datetimeLastUpdated', datetimeLastUpdated);
                    localVarPath = "/files/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (datetimeLastUpdated !== undefined) {
                        localVarQueryParameter['datetimeLastUpdated'] = datetimeLastUpdated;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fileRecordMetadata, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Create a file record object for a file uploaded by user.
         * @param {File} file Only .txt, .pdf, .pptx, and .docx files are allowed.
         * @param {PrivacyLevel} privacyLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesPost: function (file, privacyLevel, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'file' is not null or undefined
                            (0, common_1.assertParamExists)('filesPost', 'file', file);
                            // verify required parameter 'privacyLevel' is not null or undefined
                            (0, common_1.assertParamExists)('filesPost', 'privacyLevel', privacyLevel);
                            localVarPath = "/files";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            if (privacyLevel !== undefined) {
                                localVarFormParams.append('privacyLevel', privacyLevel);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.FilesApiAxiosParamCreator = FilesApiAxiosParamCreator;
/**
 * FilesApi - functional programming interface
 * @export
 */
var FilesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FilesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get all the user\'s file record objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a file record object with a specific id and its associated files.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesIdDelete: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filesIdDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a file record object with a specific id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesIdGet: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filesIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a file record object with a specific id
         * @param {string} id
         * @param {string} datetimeLastUpdated
         * @param {FileRecordMetadata} [fileRecordMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesIdPatch: function (id, datetimeLastUpdated, fileRecordMetadata, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filesIdPatch(id, datetimeLastUpdated, fileRecordMetadata, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a file record object for a file uploaded by user.
         * @param {File} file Only .txt, .pdf, .pptx, and .docx files are allowed.
         * @param {PrivacyLevel} privacyLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesPost: function (file, privacyLevel, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filesPost(file, privacyLevel, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FilesApiFp = FilesApiFp;
/**
 * FilesApi - factory interface
 * @export
 */
var FilesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FilesApiFp)(configuration);
    return {
        /**
         *
         * @summary Get all the user\'s file record objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesGet: function (options) {
            return localVarFp.filesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a file record object with a specific id and its associated files.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesIdDelete: function (id, options) {
            return localVarFp.filesIdDelete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a file record object with a specific id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesIdGet: function (id, options) {
            return localVarFp.filesIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a file record object with a specific id
         * @param {string} id
         * @param {string} datetimeLastUpdated
         * @param {FileRecordMetadata} [fileRecordMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesIdPatch: function (id, datetimeLastUpdated, fileRecordMetadata, options) {
            return localVarFp.filesIdPatch(id, datetimeLastUpdated, fileRecordMetadata, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a file record object for a file uploaded by user.
         * @param {File} file Only .txt, .pdf, .pptx, and .docx files are allowed.
         * @param {PrivacyLevel} privacyLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesPost: function (file, privacyLevel, options) {
            return localVarFp.filesPost(file, privacyLevel, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FilesApiFactory = FilesApiFactory;
/**
 * FilesApi - object-oriented interface
 * @export
 * @class FilesApi
 * @extends {BaseAPI}
 */
var FilesApi = /** @class */ (function (_super) {
    __extends(FilesApi, _super);
    function FilesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get all the user\'s file record objects.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    FilesApi.prototype.filesGet = function (options) {
        var _this = this;
        return (0, exports.FilesApiFp)(this.configuration).filesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a file record object with a specific id and its associated files.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    FilesApi.prototype.filesIdDelete = function (id, options) {
        var _this = this;
        return (0, exports.FilesApiFp)(this.configuration).filesIdDelete(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a file record object with a specific id
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    FilesApi.prototype.filesIdGet = function (id, options) {
        var _this = this;
        return (0, exports.FilesApiFp)(this.configuration).filesIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a file record object with a specific id
     * @param {string} id
     * @param {string} datetimeLastUpdated
     * @param {FileRecordMetadata} [fileRecordMetadata]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    FilesApi.prototype.filesIdPatch = function (id, datetimeLastUpdated, fileRecordMetadata, options) {
        var _this = this;
        return (0, exports.FilesApiFp)(this.configuration).filesIdPatch(id, datetimeLastUpdated, fileRecordMetadata, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a file record object for a file uploaded by user.
     * @param {File} file Only .txt, .pdf, .pptx, and .docx files are allowed.
     * @param {PrivacyLevel} privacyLevel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    FilesApi.prototype.filesPost = function (file, privacyLevel, options) {
        var _this = this;
        return (0, exports.FilesApiFp)(this.configuration).filesPost(file, privacyLevel, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FilesApi;
}(base_1.BaseAPI));
exports.FilesApi = FilesApi;
/**
 * ModelsApi - axios parameter creator
 * @export
 */
var ModelsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get all the available deployed Large Language Models (LLMs)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/models";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ModelsApiAxiosParamCreator = ModelsApiAxiosParamCreator;
/**
 * ModelsApi - functional programming interface
 * @export
 */
var ModelsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ModelsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get all the available deployed Large Language Models (LLMs)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.modelsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ModelsApiFp = ModelsApiFp;
/**
 * ModelsApi - factory interface
 * @export
 */
var ModelsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ModelsApiFp)(configuration);
    return {
        /**
         *
         * @summary Get all the available deployed Large Language Models (LLMs)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelsGet: function (options) {
            return localVarFp.modelsGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ModelsApiFactory = ModelsApiFactory;
/**
 * ModelsApi - object-oriented interface
 * @export
 * @class ModelsApi
 * @extends {BaseAPI}
 */
var ModelsApi = /** @class */ (function (_super) {
    __extends(ModelsApi, _super);
    function ModelsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get all the available deployed Large Language Models (LLMs)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelsApi
     */
    ModelsApi.prototype.modelsGet = function (options) {
        var _this = this;
        return (0, exports.ModelsApiFp)(this.configuration).modelsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ModelsApi;
}(base_1.BaseAPI));
exports.ModelsApi = ModelsApi;
/**
 * MonitoringApi - axios parameter creator
 * @export
 */
var MonitoringApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Checks the health status of the service and all connected services.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deepHealthGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/deep-health";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Checks the health status of the service. Does not include connected services.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/health";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Returns the current version of the service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        versionGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/version";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.MonitoringApiAxiosParamCreator = MonitoringApiAxiosParamCreator;
/**
 * MonitoringApi - functional programming interface
 * @export
 */
var MonitoringApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MonitoringApiAxiosParamCreator)(configuration);
    return {
        /**
         * Checks the health status of the service and all connected services.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deepHealthGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deepHealthGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Checks the health status of the service. Does not include connected services.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.healthGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns the current version of the service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        versionGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.versionGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.MonitoringApiFp = MonitoringApiFp;
/**
 * MonitoringApi - factory interface
 * @export
 */
var MonitoringApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MonitoringApiFp)(configuration);
    return {
        /**
         * Checks the health status of the service and all connected services.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deepHealthGet: function (options) {
            return localVarFp.deepHealthGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Checks the health status of the service. Does not include connected services.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthGet: function (options) {
            return localVarFp.healthGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the current version of the service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        versionGet: function (options) {
            return localVarFp.versionGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MonitoringApiFactory = MonitoringApiFactory;
/**
 * MonitoringApi - object-oriented interface
 * @export
 * @class MonitoringApi
 * @extends {BaseAPI}
 */
var MonitoringApi = /** @class */ (function (_super) {
    __extends(MonitoringApi, _super);
    function MonitoringApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Checks the health status of the service and all connected services.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringApi
     */
    MonitoringApi.prototype.deepHealthGet = function (options) {
        var _this = this;
        return (0, exports.MonitoringApiFp)(this.configuration).deepHealthGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Checks the health status of the service. Does not include connected services.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringApi
     */
    MonitoringApi.prototype.healthGet = function (options) {
        var _this = this;
        return (0, exports.MonitoringApiFp)(this.configuration).healthGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the current version of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringApi
     */
    MonitoringApi.prototype.versionGet = function (options) {
        var _this = this;
        return (0, exports.MonitoringApiFp)(this.configuration).versionGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MonitoringApi;
}(base_1.BaseAPI));
exports.MonitoringApi = MonitoringApi;
